var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "business-profile-container" }, [
    _vm.loading
      ? _c(
          "div",
          { staticClass: "loading-overlay" },
          [
            _c("a-spin", {
              attrs: { size: "large", tip: "Profil bilgileri yükleniyor..." },
            }),
          ],
          1
        )
      : _c("div", { staticClass: "business-profile-content" }, [
          _c("div", { staticClass: "profile-header-bar" }, [
            _c("div", { staticClass: "header-left" }, [
              _c("h2", { staticClass: "page-title" }, [
                _vm._v("Business Profile"),
              ]),
              _vm._v(" "),
              _vm.profile.lastSyncedAt
                ? _c("span", { staticClass: "last-sync-time" }, [
                    _c("i", { staticClass: "fa fa-clock-o" }),
                    _vm._v(
                      "\n                    Son güncelleme: " +
                        _vm._s(_vm.formatDate(_vm.profile.lastSyncedAt)) +
                        "\n                "
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "header-right" },
              [
                _c(
                  "a-button",
                  {
                    attrs: {
                      type: "primary",
                      loading: _vm.refreshing,
                      disabled: !_vm.canRefresh,
                      size: "large",
                    },
                    on: { click: _vm.refreshProfile },
                  },
                  [
                    _c("i", { staticClass: "fa fa-refresh" }),
                    _vm._v(
                      "\n                    Meta'dan Güncelle\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                !_vm.canRefresh
                  ? _c("div", { staticClass: "refresh-cooldown" }, [
                      _c("i", { staticClass: "fa fa-hourglass-half" }),
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.remainingTime) +
                          "s bekleyin\n                "
                      ),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "waba-status-section" }, [
            _c("h3", { staticClass: "section-title" }, [
              _vm._v("WhatsApp Business Account Bilgileri"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "status-cards-primary" }, [
              _c("div", { staticClass: "status-card-large" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "card-body" }, [
                  _c("div", { staticClass: "info-row" }, [
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v("Verified Name:"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "info-value verified" }, [
                      _vm._v(_vm._s(_vm.profile.wabaInfo.verifiedName)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-row" }, [
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v("Phone Number:"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "info-value" }, [
                      _vm._v(_vm._s(_vm.profile.wabaInfo.displayPhoneNumber)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-row" }, [
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v("Code Verification:"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "info-value",
                        class:
                          _vm.profile.wabaInfo.codeVerificationStatus ===
                          "VERIFIED"
                            ? "verified"
                            : "pending",
                      },
                      [
                        _vm._v(
                          "\n                                " +
                            _vm._s(
                              _vm.profile.wabaInfo.codeVerificationStatus
                            ) +
                            "\n                            "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "status-card-large" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "card-body" }, [
                  _c("div", { staticClass: "info-row" }, [
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v("Account Status:"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "info-value",
                        class:
                          "status-" +
                          _vm.profile.wabaInfo.accountStatus.toLowerCase(),
                      },
                      [
                        _vm._v(
                          "\n                                " +
                            _vm._s(
                              _vm.accountStatus[
                                _vm.profile.wabaInfo.accountStatus
                              ].text
                            ) +
                            "\n                            "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-row" }, [
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v("Phone Quality:"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "info-value",
                        class:
                          "quality-" +
                          _vm.profile.wabaInfo.phoneQuality.toLowerCase(),
                      },
                      [
                        _vm._v(
                          "\n                                " +
                            _vm._s(
                              _vm.phoneQuality[
                                _vm.profile.wabaInfo.phoneQuality
                              ].text
                            ) +
                            "\n                            "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-row" }, [
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v("Account Mode:"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "info-value" }, [
                      _vm._v(_vm._s(_vm.profile.wabaInfo.accountMode || "N/A")),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "status-card-large" }, [
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "card-body" }, [
                  _c("div", { staticClass: "info-row" }, [
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v("Platform Type:"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "info-value" }, [
                      _vm._v(_vm._s(_vm.profile.wabaInfo.platformType)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-row" }, [
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v("Throughput Level:"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "info-value" }, [
                      _vm._v(_vm._s(_vm.profile.wabaInfo.throughputLevel)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-row" }, [
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v("2FA PIN:"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "info-value",
                        class: _vm.profile.wabaInfo.isPinEnabled
                          ? "verified"
                          : "",
                      },
                      [
                        _vm._v(
                          "\n                                " +
                            _vm._s(
                              _vm.profile.wabaInfo.isPinEnabled
                                ? "Enabled"
                                : "Disabled"
                            ) +
                            "\n                            "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "status-cards-secondary" }, [
              _c(
                "div",
                {
                  staticClass: "status-mini-card",
                  class:
                    _vm.accountStatus[_vm.profile.wabaInfo.accountStatus].color,
                },
                [
                  _c("i", { staticClass: "fa fa-shield card-icon" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-content" }, [
                    _c("div", { staticClass: "card-value" }, [
                      _vm._v(
                        _vm._s(
                          _vm.accountStatus[_vm.profile.wabaInfo.accountStatus]
                            .text
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-label" }, [
                      _vm._v("Hesap Durumu"),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "status-mini-card",
                  class:
                    _vm.phoneQuality[_vm.profile.wabaInfo.phoneQuality].color,
                },
                [
                  _c("i", { staticClass: "fa fa-star card-icon" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-content" }, [
                    _c("div", { staticClass: "card-value" }, [
                      _vm._v(
                        _vm._s(
                          _vm.phoneQuality[_vm.profile.wabaInfo.phoneQuality]
                            .text
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-label" }, [
                      _vm._v("Telefon Kalitesi"),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "status-mini-card success" }, [
                _c("i", { staticClass: "fa fa-paper-plane card-icon" }),
                _vm._v(" "),
                _c("div", { staticClass: "card-content" }, [
                  _c("div", { staticClass: "card-value" }, [
                    _vm._v(
                      _vm._s(
                        _vm.formatMessagingLimit(
                          _vm.profile.wabaInfo.messagingLimit
                        )
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-label" }, [
                    _vm._v("Günlük Limit"),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "status-mini-card",
                  class:
                    _vm.canSendMessage[_vm.profile.wabaInfo.canSendMessage]
                      .color,
                },
                [
                  _c("i", { staticClass: "fa fa-bolt card-icon" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-content" }, [
                    _c("div", { staticClass: "card-value" }, [
                      _vm._v(
                        _vm._s(
                          _vm.canSendMessage[
                            _vm.profile.wabaInfo.canSendMessage
                          ].text
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-label" }, [
                      _vm._v("Mesaj Gönderimi"),
                    ]),
                  ]),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "profile-info-section" }, [
            _c("h3", { staticClass: "section-title" }, [
              _vm._v("İşletme Bilgileri"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "profile-grid" }, [
              _c("div", { staticClass: "profile-picture-card" }, [
                _c("div", { staticClass: "card-label" }, [
                  _vm._v("Profil Fotoğrafı"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "profile-picture" }, [
                  _c("img", {
                    attrs: {
                      src:
                        _vm.profile.profilePictureUrl || "/default-avatar.png",
                      alt: "Profile",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "picture-upload-overlay" },
                    [
                      _c(
                        "a-upload",
                        {
                          attrs: {
                            beforeUpload: _vm.handleProfilePictureUpload,
                            showUploadList: false,
                            accept: "image/*",
                          },
                        },
                        [
                          _c(
                            "a-button",
                            { attrs: { type: "primary", size: "small" } },
                            [
                              _c("i", { staticClass: "fa fa-camera" }),
                              _vm._v(
                                "\n                                    Değiştir\n                                "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "profile-picture-note" }, [
                  _vm._v(
                    "\n                        JPG veya PNG (max 5MB, önerilen: 640x640px)\n                    "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-field full-width" },
                [
                  _vm._m(3),
                  _vm._v(" "),
                  _c("a-textarea", {
                    attrs: {
                      "auto-size": { minRows: 3, maxRows: 5 },
                      placeholder:
                        "İşletmeniz hakkında kısa bir açıklama yazın...",
                      maxLength: 139,
                      showCount: "",
                    },
                    model: {
                      value: _vm.profile.about,
                      callback: function ($$v) {
                        _vm.$set(_vm.profile, "about", $$v)
                      },
                      expression: "profile.about",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "field-hint" }, [
                    _vm._v(
                      "WhatsApp profilinizde görünecek kısa açıklama (max 139 karakter)"
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-field full-width" },
                [
                  _c("label", { staticClass: "field-label" }, [
                    _vm._v("İşletme Açıklaması"),
                  ]),
                  _vm._v(" "),
                  _c("a-textarea", {
                    attrs: {
                      "auto-size": { minRows: 4, maxRows: 6 },
                      placeholder: "İşletmenizin detaylı açıklamasını yazın...",
                      maxLength: 512,
                      showCount: "",
                    },
                    model: {
                      value: _vm.profile.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.profile, "description", $$v)
                      },
                      expression: "profile.description",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "field-hint" }, [
                    _vm._v("İşletmenizin detaylı açıklaması"),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-field" },
                [
                  _c("label", { staticClass: "field-label" }, [
                    _vm._v("İletişim E-postası"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-input",
                    {
                      attrs: { placeholder: "ornek@sirket.com", type: "email" },
                      model: {
                        value: _vm.profile.email,
                        callback: function ($$v) {
                          _vm.$set(_vm.profile, "email", $$v)
                        },
                        expression: "profile.email",
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-envelope",
                        attrs: { slot: "prefix" },
                        slot: "prefix",
                      }),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-field" },
                [
                  _c("label", { staticClass: "field-label" }, [
                    _vm._v("İşletme Adresi"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-input",
                    {
                      attrs: { placeholder: "Tam adres bilgisi" },
                      model: {
                        value: _vm.profile.address,
                        callback: function ($$v) {
                          _vm.$set(_vm.profile, "address", $$v)
                        },
                        expression: "profile.address",
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-map-marker",
                        attrs: { slot: "prefix" },
                        slot: "prefix",
                      }),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-field" },
                [
                  _c("label", { staticClass: "field-label" }, [
                    _vm._v("Website 1"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-input",
                    {
                      attrs: { placeholder: "https://www.sirket.com" },
                      on: { change: _vm.updateWebsites },
                      model: {
                        value: _vm.websiteInputs.website1,
                        callback: function ($$v) {
                          _vm.$set(_vm.websiteInputs, "website1", $$v)
                        },
                        expression: "websiteInputs.website1",
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-globe",
                        attrs: { slot: "prefix" },
                        slot: "prefix",
                      }),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-field" },
                [
                  _c("label", { staticClass: "field-label" }, [
                    _vm._v("Website 2"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-input",
                    {
                      attrs: { placeholder: "https://www.facebook.com/sirket" },
                      on: { change: _vm.updateWebsites },
                      model: {
                        value: _vm.websiteInputs.website2,
                        callback: function ($$v) {
                          _vm.$set(_vm.websiteInputs, "website2", $$v)
                        },
                        expression: "websiteInputs.website2",
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-globe",
                        attrs: { slot: "prefix" },
                        slot: "prefix",
                      }),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-field full-width" },
                [
                  _vm._m(4),
                  _vm._v(" "),
                  _c(
                    "a-select",
                    {
                      attrs: {
                        size: "large",
                        placeholder: "İşletme kategorisi seçin",
                      },
                      model: {
                        value: _vm.profile.vertical,
                        callback: function ($$v) {
                          _vm.$set(_vm.profile, "vertical", $$v)
                        },
                        expression: "profile.vertical",
                      },
                    },
                    _vm._l(_vm.verticals, function (vertical) {
                      return _c(
                        "a-select-option",
                        {
                          key: vertical.value,
                          attrs: { value: vertical.value },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(vertical.label) +
                              "\n                        "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "field-hint" }, [
                    _vm._v("İşletmenizin faaliyet alanını seçin"),
                  ]),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _vm.hasChanges
            ? _c(
                "div",
                { staticClass: "action-bar" },
                [
                  _c(
                    "a-button",
                    { attrs: { size: "large" }, on: { click: _vm.resetForm } },
                    [
                      _c("i", { staticClass: "fa fa-undo" }),
                      _vm._v(
                        "\n                Değişiklikleri Geri Al\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "large",
                        loading: _vm.isSaving,
                      },
                      on: { click: _vm.saveProfile },
                    },
                    [
                      _c("i", { staticClass: "fa fa-save" }),
                      _vm._v("\n                Güncelle\n            "),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header" }, [
      _c("i", { staticClass: "fa fa-phone" }),
      _vm._v(" "),
      _c("span", [_vm._v("Telefon Bilgileri")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header" }, [
      _c("i", { staticClass: "fa fa-info-circle" }),
      _vm._v(" "),
      _c("span", [_vm._v("Hesap Durumu")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header" }, [
      _c("i", { staticClass: "fa fa-cog" }),
      _vm._v(" "),
      _c("span", [_vm._v("Platform Ayarları")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "field-label" }, [
      _vm._v("\n                        Hakkında Metni "),
      _c("span", { staticClass: "required" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "field-label" }, [
      _vm._v("\n                        İşletme Kategorisi "),
      _c("span", { staticClass: "required" }, [_vm._v("*")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }